import React from 'react'
import { connect } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'

function ProgressDialog ({ operationProgress: { operationInProgress } }) {
  return (
    <Dialog open={operationInProgress} PaperProps={{ elevation: 2, sx: { borderRadius: 20 } }}>
      <DialogContent>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  )
}

const mapStateToProps = ({ operationProgress }) => ({ operationProgress })

export default connect(mapStateToProps)(ProgressDialog)
